tinymce.addI18n("kab", {
    "#": "",
    "Accessibility": "",
    "Accordion": "",
    "Accordion body...": "",
    "Accordion summary...": "",
    "Action": "Tigawt",
    "Activity": "Armud",
    "Address": "Tansa",
    "Advanced": "Ana\u1e93i",
    "Align": "Settef",
    "Align center": "Di tlemast",
    "Align left": "Tarigla \u0263er zelma\u1e0d",
    "Align right": "tarigla \u0263er zelma\u1e0d",
    "Alignment": "Tarigla",
    "Alignment {0}": "",
    "All": "Akk",
    "Alternative description": "",
    "Alternative source": "A\u0263balu amlellay",
    "Alternative source URL": "A\u0263balu n URL amlellay",
    "Anchor": "",
    "Anchor...": "Tamdeyt...",
    "Anchors": "Timdyin",
    "Animals and Nature": "i\u0263ersiwen akked ugama",
    "Arrows": "Tineccabin",
    "B": "",
    "Background color": "Ini n ugilal",
    "Background color {0}": "",
    "Black": "Aberkan",
    "Block": "Sew\u1e25el",
    "Block {0}": "",
    "Blockquote": "Tanebdurt",
    "Blocks": "I\u1e25edran",
    "Blue": "Anili",
    "Blue component": "",
    "Body": "Tafka",
    "Bold": "Tira tazurant",
    "Border": "Iri",
    "Border color": "Ini n yiri",
    "Border style": "A\u0263anib n yiri",
    "Border width": "Tehri n yiri",
    "Bottom": "Uksar",
    "Browse files": "",
    "Browse for an image": "Snirem iwakken ad tferne\u1e0d tugna",
    "Browse links": "",
    "Bullet list": "Tabdart s tlillac",
    "Cancel": "Semmet",
    "Caption": "",
    "Cell": "Taxxamt",
    "Cell padding": "Tama n texxamt",
    "Cell properties": "Iraten n texxamt",
    "Cell spacing": "Tlunt ger texxamin",
    "Cell styles": "",
    "Cell type": "Anaw n texxamt",
    "Center": "Di tlemmast",
    "Characters": "Isekkilen",
    "Characters (no spaces)": "Isekkilen (tallunin ur ttekkint ara)",
    "Circle": "Tawinest",
    "Class": "Asmil",
    "Clear formatting": "",
    "Close": "Mdel",
    "Code": "Tangalt",
    "Code sample...": "Amedya n tengalt...",
    "Code view": "Abeqqe\u1e0d n tengalt",
    "Color Picker": "Amelqa\u1e0d n yini",
    "Color swatch": "Talemmict n yini",
    "Cols": "Tigejda",
    "Column": "Tagejdit",
    "Column clipboard actions": "",
    "Column group": "Agraw n tgejda",
    "Column header": "",
    "Constrain proportions": "",
    "Copy": "N\u0263el",
    "Copy column": "",
    "Copy row": "N\u0263el adur",
    "Could not find the specified string.": "Ur d-nufi ara azrar i d-yettunefken.",
    "Could not load emojis": "",
    "Count": "A\u0263rud",
    "Currency": "Adrim",
    "Current window": "Asfaylu amiran",
    "Custom color": "",
    "Custom...": "",
    "Cut": "Gzem",
    "Cut column": "",
    "Cut row": "Gzem adur",
    "Dark Blue": "Anili a\u0263mayan",
    "Dark Gray": "Amelli\u0263di a\u0263mayan",
    "Dark Green": "Azegzaw a\u0263mayan",
    "Dark Orange": "A\u010dinawi a\u0263mayan",
    "Dark Purple": "Amidadi a\u0263mayan",
    "Dark Red": "Azegga\u0263 a\u0263mayan",
    "Dark Turquoise": "Ajenjari a\u0263mayan",
    "Dark Yellow": "Awra\u0263 a\u0263mayan",
    "Dashed": "",
    "Date/time": "Azemz/Asrag",
    "Decrease indent": "Simc\u1e6du\u1e25 asi\u1e93i",
    "Default": "Lex\u1e63as",
    "Delete accordion": "",
    "Delete column": "Kkes tagejdit",
    "Delete row": "Kkes tagejdit",
    "Delete table": "Kkes tafelwit",
    "Dimensions": "Tisekta",
    "Disc": "A\u1e0debsi",
    "Div": "",
    "Document": "Isemli",
    "Dotted": "",
    "Double": "",
    "Drop an image here": "Ssers tugna dagi",
    "Dropped file type is not supported": "",
    "Edit": "\u1e92reg",
    "Embed": "",
    "Emojis": "",
    "Emojis...": "",
    "Error": "Tucc\u1e0da",
    "Error: Form submit field collision.": "Tucc\u1e0da: amgirred n wurtan di tuzzna n tferkit.",
    "Error: No form element found.": "Ulac aferdis n tferkit i yettwafen.",
    "Extended Latin": "Talatinit ye\u1e93len",
    "Failed to initialize plugin: {0}": "Tucc\u1e0da deg wallus n uwennez n usi\u0263zef: {0}",
    "Failed to load plugin url: {0}": "Tucc\u1e0da deg usali n usi\u0263zef: {0}",
    "Failed to load plugin: {0} from url {1}": "Tucc\u1e0da deg usili n usi\u0263zef: {0} seg url {1}",
    "Failed to upload image: {0}": "Tucc\u1e0da deg usili n tugna: {0}",
    "File": "Afaylu",
    "Find": "Nadi",
    "Find (if searchreplace plugin activated)": "Nadi (ma yermed uzegrir searchreplace)",
    "Find and Replace": "",
    "Find and replace...": "Nadi semselsi...",
    "Find in selection": "Af-d di tefrayt",
    "Find whole words only": "Af-d awal ummid kan",
    "Flags": "Annayen",
    "Focus to contextual toolbar": "Asa\u1e0des \u0263ef tfeggagt n ifecka tanattalt",
    "Focus to element path": "Asa\u1e0des \u0263ef ubrid n uferdis",
    "Focus to menubar": "Asa\u1e0des \u0263ef tfeggagt n wumu\u0263",
    "Focus to toolbar": "Asa\u1e0des \u0263ef tfeggagt n ifecka",
    "Font": "Tasefsit",
    "Font size {0}": "",
    "Font sizes": "",
    "Font {0}": "",
    "Fonts": "Tisefsa",
    "Food and Drink": "Tu\u010d\u010dit akked tisit",
    "Footer": "A\u1e0dar",
    "Format": "Amasal",
    "Format {0}": "",
    "Formats": "Imasalen",
    "Fullscreen": "Agdil a\u010duran",
    "G": "",
    "General": "Amatu",
    "Gray": "Amelli\u0263di",
    "Green": "Azegzaw",
    "Green component": "",
    "Groove": "",
    "Handy Shortcuts": "Inegzumen",
    "Header": "Tasenti\u1e0dt",
    "Header cell": "Tasen\u1e6di\u1e0dt n texxamt",
    "Heading 1": "Inixf 1",
    "Heading 2": "Inixf 2",
    "Heading 3": "Inixf 3",
    "Heading 4": "Inixf 4",
    "Heading 5": "Inixf 5",
    "Heading 6": "Inixf 6",
    "Headings": "Izewlen",
    "Height": "Te\u0263zi",
    "Help": "Tallalt",
    "Hex color code": "",
    "Hidden": "",
    "Horizontal align": "",
    "Horizontal line": "Ajerri\u1e0d aglawan",
    "Horizontal space": "Talunt taglawant",
    "ID": "",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "",
    "Image is decorative": "",
    "Image list": "Tabdart n tugniwin",
    "Image title": "Azwel n tugna",
    "Image...": "Tugna...",
    "ImageProxy HTTP error: Could not find Image Proxy": "",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "",
    "ImageProxy HTTP error: Rejected request": "",
    "ImageProxy HTTP error: Unknown ImageProxy error": "",
    "Increase indent": "Sim\u0263ur asi\u1e93i",
    "Inline": "",
    "Insert": "Ger",
    "Insert Template": "",
    "Insert accordion": "",
    "Insert column after": "Sente\u1e0d tagejdit deffir",
    "Insert column before": "Sente\u1e0d tagejdit sdat",
    "Insert date/time": "Ger azemz/asrag",
    "Insert image": "Ger tugna",
    "Insert link (if link plugin activated)": "Ger ase\u0263wen (ma yermed uzegrir n use\u0263wen)",
    "Insert row after": "Ger adur sdat",
    "Insert row before": "Ger adur deffir",
    "Insert table": "Ger tafelwit",
    "Insert template...": "Ger tane\u0263ruft...",
    "Insert video": "Ger avidyu",
    "Insert/Edit code sample": "Ger/\u1e92reg tangalt n umedya",
    "Insert/edit image": "Ger/\u1e92reg tugna",
    "Insert/edit link": "Ger/\u1e93reg azday",
    "Insert/edit media": "Ger/\u1e92reg amiya",
    "Insert/edit video": "Ger/\u1e93reg avidyu",
    "Inset": "",
    "Invalid hex color code: {0}": "",
    "Invalid input": "",
    "Italic": "Tira yeknan",
    "Justify": "",
    "Keyboard Navigation": "Tunigin s unasiw",
    "Language": "Tutlayt",
    "Learn more...": "\u1e92er ugar...",
    "Left": "\u0194er zelma\u1e0d",
    "Left to right": "Seg zelma\u1e0d \u0263er yefus",
    "Light Blue": "Anili afaw",
    "Light Gray": "Amelli\u0263di afaw",
    "Light Green": "Azegzaw afaw",
    "Light Purple": "Amidadi afaw",
    "Light Red": "Azegga\u0263 afaw",
    "Light Yellow": "Awra\u0263 afaw",
    "Line height": "",
    "Link list": "Tabdart n is\u0263ewnen",
    "Link...": "As\u0263en...",
    "List Properties": "",
    "List properties...": "",
    "Loading emojis...": "",
    "Loading...": "",
    "Lower Alpha": "Alpha ame\u1e93yan",
    "Lower Greek": "Grik ame\u1e93yan",
    "Lower Roman": "Ruman amectu\u1e25",
    "Match case": "",
    "Mathematical": "Inemhalen usnaken",
    "Media poster (Image URL)": "Abeqqi\u1e0d n umidya (URL n tugna)",
    "Media...": "Amidya...",
    "Medium Blue": "Anili alemmas",
    "Medium Gray": "Amelli\u0263di alemmas",
    "Medium Purple": "Amidadi alemmas",
    "Merge cells": "Seddukel tixxamin",
    "Middle": "Di tlemmast",
    "Midnight Blue": "Anili n yi\u1e0d",
    "More...": "Ugar...",
    "Name": "Isem",
    "Navy Blue": "Anili n yilel",
    "New document": "Attaftar amaynut",
    "New window": "Asfaylu amaynut",
    "Next": "Win \u0263ers",
    "No": "Ala",
    "No alignment": "",
    "No color": "Ulac ini",
    "Nonbreaking space": "Talunt ur nettwagzam ara",
    "None": "Ulac",
    "Numbered list": "Tabdart s wu\u1e6d\u1e6dunen",
    "OR": "Ih",
    "Objects": "Ti\u0263awsiwin",
    "Ok": "Ih",
    "Open help dialog": "Ldi tankult n udiwenni n tallelt",
    "Open link": "Ldi ase\u0263wen",
    "Open link in...": "Ldi as\u0263en di...",
    "Open popup menu for split buttons": "",
    "Orange": "A\u010d\u010dinawi",
    "Outset": "",
    "Page break": "Angaz n usebter",
    "Paragraph": "taseddart",
    "Paste": "Sente\u1e0d",
    "Paste as text": "Sente\u1e0d d a\u1e0dris",
    "Paste column after": "",
    "Paste column before": "",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "",
    "Paste or type a link": "Sente\u1e0d ne\u0263 sekcem ase\u0263wen",
    "Paste row after": "Sente\u1e0d adur deffir",
    "Paste row before": "Sente\u1e0d adur sdat",
    "Paste your embed code below:": "",
    "People": "L\u0263aci",
    "Plugins": "Isi\u0263zifen",
    "Plugins installed ({0}):": "Izegriren yettwasbedden ({0}):",
    "Powered by {0}": "Iteddu s {0} ",
    "Pre": "",
    "Preferences": "Imenyafen",
    "Preformatted": "Yettwamsel si tazwara",
    "Premium plugins:": "Izegriren premium :",
    "Press the Up and Down arrow keys to resize the editor.": "",
    "Press the arrow keys to resize the editor.": "",
    "Press {0} for help": "",
    "Preview": "Sken",
    "Previous": "Uzwir",
    "Print": "",
    "Print...": "Siggez...",
    "Purple": "Amidadi",
    "Quotations": "Tinebdurin",
    "R": "",
    "Range 0 to 255": "",
    "Red": "Azegga\u0263",
    "Red component": "",
    "Redo": "Err-d",
    "Remove": "",
    "Remove color": "Kkes ini",
    "Remove link": "Kkes azday",
    "Replace": "Semselsi",
    "Replace all": "Semselsi kulec",
    "Replace with": "Semselsi s",
    "Resize": "Beddel tiddi",
    "Restore last draft": "",
    "Reveal or hide additional toolbar items": "",
    "Rich Text Area": "",
    "Rich Text Area. Press ALT-0 for help.": "Ta\u0263zut n u\u1e0dris anesba\u0263ur. Ssed ALT-0 i tallelt.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "",
    "Ridge": "",
    "Right": "\u0194er yefus",
    "Right to left": "Seg yefus \u0263er zelma\u1e0d",
    "Row": "Adur",
    "Row clipboard actions": "",
    "Row group": "Agraw n waduren",
    "Row header": "",
    "Row properties": "Iraten n udur",
    "Row type": "Anaw n wadur",
    "Rows": "Aduren",
    "Save": "Sekles",
    "Save (if save plugin activated)": "Sekles (ma yermed uzegrir save)",
    "Scope": "",
    "Search": "Nadi",
    "Select all": "Fren kulec",
    "Select...": "Fren...",
    "Selection": "Tafrayt",
    "Shortcut": "Anegzum",
    "Show blocks": "Beqqe\u1e0d i\u1e25edran",
    "Show caption": "Sken taw\u1e6d\u1e6dfa",
    "Show invisible characters": "Beqqe\u1e0d isekkilen uffiren",
    "Size": "Tiddi",
    "Solid": "",
    "Source": "A\u0263balu",
    "Source code": "Tangalt ta\u0263balut",
    "Special Character": "",
    "Special character...": "Isekkilen uzzigen...",
    "Split cell": "B\u1e0du tixxamin",
    "Square": "Amku\u1e93",
    "Start list at number": "",
    "Strikethrough": "",
    "Style": "A\u0263anib",
    "Subscript": "",
    "Superscript": "",
    "Switch to or from fullscreen mode": "Kcem ne\u0263 ffe\u0263 agdil a\u010d\u010duran",
    "Symbols": "Izamulen",
    "System Font": "Anagraw n tsefsa",
    "Table": "Tafelwit",
    "Table caption": "",
    "Table properties": "Iraten n tfelwit",
    "Table styles": "",
    "Template": "Tine\u0263rufin",
    "Templates": "Timudimin",
    "Text": "A\u1e0dris",
    "Text color": "Ini n u\u1e0dris",
    "Text color {0}": "",
    "Text to display": "A\u1e0dris ara yettwabeqq\u1e0den",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "URL i teskecme\u1e0d tettban-d d tansa email. teb\u0263i\u1e0d ad s-ternu\u1e0d azwir mailto : ?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "URL i teskecme\u1e0d tettban-d d azday uffi\u0263. Teb\u0263i\u1e0d ad s-ternu\u1e0d azwir http://  ?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "",
    "Title": "Azwel",
    "To open the popup, press Shift+Enter": "Iwakken ad teldi\u1e0d asfaylu udhim, ssed Shift+Kcem",
    "Toggle accordion": "",
    "Tools": "Ifecka",
    "Top": "Uksawen",
    "Travel and Places": "Asikel akked ime\u1e0dqan",
    "Turquoise": "Ajenjari",
    "Underline": "Aderrer",
    "Undo": "Semmet",
    "Upload": "Sili",
    "Uploading image": "",
    "Upper Alpha": "Alfa ameqran",
    "Upper Roman": "Ruman ameqran",
    "Url": "",
    "User Defined": "Yesbadu-t useqdac",
    "Valid": "Ame\u0263tu",
    "Version": "Lqem",
    "Vertical align": "",
    "Vertical space": "Talunt taratakt",
    "View": "Tamu\u0263li",
    "Visual aids": "",
    "Warn": "\u0190eyyen",
    "White": "Amellal",
    "Width": "Tehri",
    "Word count": "Am\u1e0dan n wawalen",
    "Words": "Awalen",
    "Words: {0}": "",
    "Yellow": "Awra\u0263",
    "Yes": "Ih",
    "You are using {0}": "Tsseqdace\u1e0d {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Ibeddilen ur twaskelsen ara teb\u0263i\u1e0d ad teff\u0263e\u1e0d ?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "",
    "alignment": "aderrec",
    "austral sign": "azamul n ustral",
    "cedi sign": "azamul n siddi",
    "colon sign": "azamul n kulun",
    "cruzeiro sign": "azamul n krutayru",
    "currency sign": "Azamul n wedrim",
    "dollar sign": "Azamul n dular",
    "dong sign": "azamul n dung",
    "drachma sign": "azamul n d\u1e5bacma",
    "euro-currency sign": "azamul n euro",
    "example": "amedya",
    "formatting": "amsal",
    "french franc sign": "azamul n f\u1e5bank afransi",
    "german penny symbol": "azamul n pini almani",
    "guarani sign": "azamul n gwa\u1e5bani",
    "history": "Amazray",
    "hryvnia sign": "azamul n hrivniya",
    "indentation": "asi\u1e93i",
    "indian rupee sign": "azamul n urupi ahindi",
    "kip sign": "azamul n kip",
    "lira sign": "azamul n lira",
    "livre tournois sign": "azamul lira aturnwa",
    "manat sign": "azamul n mana\u1e6d",
    "mill sign": "azamul n mil",
    "naira sign": "azamul n nayra",
    "new sheqel sign": "azamul n ciqel amaynut",
    "nordic mark sign": "azamul n ma\u1e5bk n ugafa",
    "peseta sign": "azamul n pizi\u1e6da",
    "peso sign": "azamul n pizu",
    "ruble sign": "azamul n rubl",
    "rupee sign": "azamul n urupi",
    "spesmilo sign": "azamul n spismilu",
    "styles": "i\u0263unab",
    "tenge sign": "azamul n tingi",
    "tugrik sign": "azamul n tugrik",
    "turkish lira sign": "azamul n lira a\u1e6durki",
    "won sign": "azamul n wun",
    "yen character": "azamul n yan",
    "yen/yuan character variant one": "yan/yuwan tasenfelt n usekkil yiwen",
    "yuan character": "azamul n yuwan",
    "yuan character, in hong kong and taiwan": "asekkil n yuwan, di hunkung akked \u1e6daywan",
    "{0} characters": "{0} n yisekkilen",
    "{0} columns, {1} rows": "",
    "{0} words": "{0} n wawalen"
});